export const ChartsLayout = ({ children }: React.PropsWithChildren) => {
  return <div className="mb-4 flex flex-col gap-10">{children}</div>;
};

export default ChartsLayout;
